import { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

// Returns the latest (max) transactionDate found on the last data point of each series.
// If no valid transactionDate is found, returns undefined.
export const getLatestTransactionDate = (
  chartSeries: ExtendedSeriesOptionsType[] | undefined
): number | undefined => {
  if (!chartSeries || chartSeries.length === 0) return undefined;

  let latest: number | undefined;

  for (const series of chartSeries) {
    const lastPoint = series?.data?.at?.(-1);
    const t = lastPoint?.custom?.transactionDate as unknown;

    let ts: number | undefined;
    if (typeof t === 'number') {
      ts = t;
    } else if (typeof t === 'string') {
      const parsed = Date.parse(t);
      ts = Number.isNaN(parsed) ? undefined : parsed;
    }

    if (typeof ts === 'number') {
      latest = latest === undefined ? ts : Math.max(latest, ts);
    }
  }

  return latest;
};
